const theme = {
  primary: '#3818d7',
  secondary: '#d718b7',
  correct: '#00ce0e',
  incorrect: '#d73818',
};

export default theme;
